import React from 'react';

import { globalHistory, Router } from '@gatsbyjs/reach-router';
import { QueryParamProvider } from 'use-query-params';

// Pages
import AccountDashboardPage from './account-dashboard/AccountDashboardPage';
import OrderListPage from './order-list/OrderListPage';
import OrderDetailPage from './order-detail-page/OrderDetailPage';
import InvoicePage from './pages/invoices/InvoicesPage';
import ChangeAscriptionPage from './pages/ascription/ChangeAscriptionPage';
import AlternativeUploadPage from './alternative-upload/AlternativeUploadPage';
import AccountDetailsPage from './account-details/AccountDetailsPage';
import QuoteDetailsPage from './quotes/quotes-detail/QuoteDetailsPage';
import QuotesFormPage from './quotes/quote-create/QuotesCreatePage';
import QuoteListPage from './quotes/quote-list/QuoteListPage';
import ComplaintCreationPage from './complaints/complaints-add/ComplaintCreationPage';
import ComplaintOrderSearchPage from './complaints/complaints-add/ComplaintOrderSearchPage';
import ComplaintsPage from './complaints/complaints-list/ComplaintsPage';
import ComplaintDetailsPage from './complaints/complaints-detail/ComplaintDetailsPage';
import NewsletterPage from './pages/NewsletterPage';
import DesignListPage from './pages/designs/DesignListPage';
import AddressListPage from './pages/address-book/AddressListPage';
import CreateAddressPage from './pages/address-book/CreateAddressPage';
import UpdateAddressPage from './pages/address-book/UpdateAddressPage';
import MandatesPage from './pages/mandates/MandatesPage';
import CreateMandatePage from './pages/mandates/CreateMandatePage';
import ViewProposalDetailPage from './proposals/ViewProposalDetail';

// Contexts
import ApiContext from './contexts/ApiContext';

// Api
import { ServiceFactory } from '../../../services/ServiceFactory';
import SurveyWidget from './widgets/surveys/SurveyWidget';

const Services = {
  invoiceApi: ServiceFactory.createInvoiceService(),
  designsApi: ServiceFactory.createDesignService(),
  paymentsApi: ServiceFactory.createPaymentV2Service(),
};

interface Props {
  baseURL: string;
}

// Why so many TS-EXPECT-ERROR's?
// @gatsbyjs/reach-router and reach/router haven't been updated in years.

const MyAccount = ({ baseURL }: Props) => (
  <ApiContext.Provider value={Services}>
    <SurveyWidget />
    <Router basepath={baseURL}>
      {/* @ts-expect-error */}
      <QueryParamProvider path="/" reachHistory={globalHistory}>
        {/* @ts-expect-error */}
        <AccountDashboardPage path="/" />
        {/* @ts-expect-error */}
        <OrderListPage path="orders" />
        {/* @ts-expect-error */}
        <OrderDetailPage path="orders/:orderId" />
        {/* @ts-expect-error */}
        <ComplaintOrderSearchPage path="complaints/add" />
        {/* @ts-expect-error */}
        <ComplaintCreationPage path="complaints/add/:orderId/:lineItemId" />
        {/* @ts-expect-error */}
        <ComplaintCreationPage path="complaints/add/:orderId" />
        {/* @ts-expect-error */}
        <ComplaintsPage path="complaints" />
        {/* @ts-expect-error */}
        <ComplaintDetailsPage path="complaints/:complaintId" />
        {/* @ts-expect-error */}
        <QuoteListPage path="quoting" />
        {/* @ts-expect-error */}
        <QuoteDetailsPage path="quoting/:quoteId" />
        {/* @ts-expect-error */}
        <QuotesFormPage path="quoting/request/new" />
        {/* @ts-expect-error */}
        <AlternativeUploadPage path="orders/:orderId/upload/:lineItemId" />
        {/* @ts-expect-error */}
        <AccountDetailsPage path="/editmain" />
        {/* @ts-expect-error */}
        <MandatesPage path="/mandates" />
        {/* @ts-expect-error */}
        <CreateMandatePage path="/mandates/add" />
        {/* @ts-expect-error */}
        <InvoicePage path="/invoices" />
        {/* @ts-expect-error */}
        <ChangeAscriptionPage path="/invoices/ascription/:invoiceNumber" />
        {/* @ts-expect-error */}
        <NewsletterPage path="/newsletter" />
        {/* @ts-expect-error */}
        <AddressListPage path="/addresses" />
        {/* @ts-expect-error */}
        <CreateAddressPage path="/addresses/create" />
        {/* @ts-expect-error */}
        <UpdateAddressPage path="/addresses/edit/:addressId" />
        {/* @ts-expect-error */}
        <DesignListPage path="/designs" />
        {/* @ts-expect-error */}
        <ViewProposalDetailPage path="/proposals/:proposalId" />
      </QueryParamProvider>
    </Router>
  </ApiContext.Provider>
);

export default MyAccount;
